import { DEFAULT_THEME_ID, getThemeById, THEME_VAR_KEYS } from './themeConfig';

export function applyTheme(themeId = DEFAULT_THEME_ID) {
  const theme = getThemeById(themeId);
  const root = document.documentElement;

  root.setAttribute('data-theme', theme.id);

  THEME_VAR_KEYS.forEach((key) => {
    const value = theme.vars[key];
    if (value != null) {
      root.style.setProperty(key, value);
    } else {
      root.style.removeProperty(key);
    }
  });

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', theme.vars['--primary-bg'] ?? '');
  }
}
